/**
 * Formats a list of job types into a comma-separated display string.
 *
 * Accepts either an array of plain strings or objects with a `label` field,
 * to accommodate the differing shapes returned by the OneGraph and legacy
 * VJ models. Returns `undefined` when the input is empty or missing so
 * callers can preserve the "no job type" signal downstream.
 */
export function formatJobTypes(
    jobTypes: ReadonlyArray<string | { label: string }> | null | undefined,
): string | undefined {
    if (!jobTypes || jobTypes.length === 0) {
        return undefined;
    }
    return jobTypes
        .map((jobType) => (typeof jobType === 'string' ? jobType : jobType.label))
        .join(', ');
}
